import _get from "lodash/get";
import { actionData } from './data/actionData';
export var getActionData = function getActionData(context, path) {
  // tslint:disable-line no-any
  return context && path ? _get(context, path) : undefined;
};
/***
 * wrap setTimeout into named function just to explain purpose of timeout
 * **/

export function nextTick(cb) {
  setTimeout(cb, 0);
}
export var emptyCallback = function emptyCallback() {}; // tslint:disable-line: no-empty

export var getConfig = function getConfig() {
  // ToDo: Phase 2: config should be saved in squiz and fetched from api gateway.
  return Promise.resolve(actionData);
};
//# sourceMappingURL=utils.js.map